import React, {Component} from 'react';
import PropTypes from 'prop-types';


import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import MenuIcon from '@mui/icons-material/Menu';
import { ListItemButton } from '@mui/material';

const s:any = {
  active: {
    color: 'primary.main',
    fontWeight: 'typography.fontWeightMedium',
  },
  itemicon: {
    minWidth: 24,
    marginRight: 1,
  }
};

class DynamicMenuParent extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;

  state = {
    open: this.props.openImmediately,
  };

  componentDidMount() {
    // So we only run this logic once.
    if (!this.props.openImmediately) {
      return;
    }

    // Center the selected item in the list container.
    const activeElement = document.querySelector(`.${this.props.classes.active}`);
    if (activeElement && activeElement.scrollIntoView) {
      activeElement.scrollIntoView({});
    }
  }

  handleClick = () => {
    this.setState((state:any) => ({ open: !state.open }));
  };

  render() {
    const {
      children,
      classes,
      onClick,
      openImmediately,
      title,
      ...other
    } = this.props;

    return (
      <React.Fragment>
      <ListItem onClick={this.handleClick} {...other}>
        <ListItemButton>
        <ListItemIcon sx={{...s.itemicon}}>
          <MenuIcon />
        </ListItemIcon>
        <ListItemText primary={title} />
        {this.state.open ? <ChevronLeft /> : <ChevronRight />}
        </ListItemButton>
      </ListItem>
      <Collapse in={this.state.open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
      </React.Fragment>
    );
  }
}

DynamicMenuParent.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  openImmediately: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

DynamicMenuParent.defaultProps = {
  openImmediately: false,
};

export default DynamicMenuParent;
